import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ConfigurationService } from '../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class AccountingpolicyService {

  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }
  apiUrl = this.ConfigService.getAPIBaseUrl() + 'api/AccountingPolicies/';
  apiUrl1 = this.ConfigService.getAPIBaseUrl() + 'api/GeneralInformation/';

  insertaccountpolicy(data: any) {
    debugger
    const httpOptions = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }
    return this.http.post(this.apiUrl + 'InsertAccountingpolicy', data)
  }

  Getaccountpolicy(id) {
    debugger
    return this.http.get(this.apiUrl + 'getAccountingpolicy?id='+ id)
  }
  GetaccountpolicyLy(id) {
    debugger
    return this.http.get(this.apiUrl + 'getAccountingpolicyLY?id=' + id)
  }


  AddBasis(data:any) {
    const httpOptions = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }
    return this.http.post(this.apiUrl1 + 'InsertAccountingBasis', data)
  }

  Getaccountingbasis(id) {
    return this.http.get(this.apiUrl1 + 'AccountingBasis?id=' + id)
  }
  GetaccountingbasisLY(id) {
    return this.http.get(this.apiUrl1 + 'AccountingBasisLY?id=' + id)
  }

  insertapprovalstatement(data) {
    const httpOptions = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }
    return this.http.post(this.apiUrl1 + 'Insertapprovalstate', data)
  }

  getapprovalstatement(id) {
    debugger
    return this.http.get(this.apiUrl1 + 'Approvalstatement?id=' + id)
  }
  getapprovalstatementLY(id) {
    debugger
    return this.http.get(this.apiUrl1 + 'ApprovalstatementLY?id=' + id)
  }
}
